<template>
    <div class="footer">
        <p style="padding-top:10px;"><a style="text-decoration:none;color:#f7f7f7;" href="https://beian.mps.gov.cn/#/query/webSearch?code=13068102000404" rel="noreferrer" target="_blank">冀公网安备13068102000404号</a></p>
	<p style="padding-top:5px;padding-bottom:5px;">京ICP备19038458号-1</p>
        <p style="padding-bottom:10px;">版权所有：北京北门逐鹿影视传媒有限公司</p>
    </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer{
    width:750px;
    
   
    text-align:center;
    background:#282828;
    color:#f7f7f7;
    font-size:16px;
}
</style>
